BingMap.Map = function () {
	//console.log('bingmap-map.js');

	//VARIABLES
	var _log = false,
		//imgBaseUrl = '', //"http://www.travelwisconsin.com",
		baseCategory = '', //populated below
		basePath = decodeURIComponent($("[data-basepath]").data("basepath")),

		breakPoints = {
			'main': 1024 //760
		},
		isMobile = false, //mobile/desktop only, 760px brkpt
		wasMobile = null,
		isTouch = $('html').hasClass('touch') ? true : false,
		isDisableZoom = isTouch,//pinch/mousewheel/zoom

		//general/config
		map = null,
		overlay = '',
		reportType = "empty",
		baseZoom = 7,
		mobileZoom = 6,
		useZoom = null,
		lastZoomLevel = 0,
		lastCenterLocation = null,
		useCenterLocation = null,
		infobox = null,
		reportInfoBoxArray = Array(),
		toMapReset,//timeout
		toMapResetMS = 30,
		isZoomingToPin = false,
		isClusteringLoaded = false,
		wisconsinMask = null,

		dataHold = null,

		colorPinSingle = '#000000',
		colorPinCluster = 'rgba(51, 51, 51, 0.5)',//'#333333',

		//layers
		clusterLayer = null,

		//location
		desktopCenter = null,
		tabletLandscapeCenter = null,
		tabletPortraitCenter = null,
		mobileCenter = null,
		centerLocation = null,

		wiBoundsOuter = null,//used for zoom-out-max
		wiBounds = null //used to place svg directly over WI
		;

	if(_log)console.log('isTouch:', isTouch);


	//TEMPLATES
	var reportsAllBodySSTemplate = $('#reportsAllBodySSTemplate').html(),
		noReportsTemplate = $('#noReportsTemplate').html(),
		pinInfoboxSSTemplate = $('#pinInfoboxSSTemplate').html(),
		//preloaderTemplate = $('#preloaderTemplate').html(),
		preloaderMapTemplate = $('#preloaderMapTemplate').html(),
		//Can't append a non-closed tag
		reportsOLOpenTemplate = '<ol class="js-region-list list-unstyled m-0">',
		reportsOLCloseTemplate = '</ol>';


	//MAP OPTIONS
	var mapOptions = {
		zoom: baseZoom,
		center: centerLocation,
		enableSearchLogo: false,
		showScalebar: false,
		showDashboard: false,
		useInertia: false,
		disableKeyboardInput: true,
		disablePanning: false, //mobile.matches, // - remove all panning for MOBILE ONLY except when using the compass buttons
		liteMode: true
	};


	/**
	 * Get if map is initialized yet
	 */
	var getMapInit = function () {
		return map;
	}



	/**
	 * Initialize Buttons
	 */
	var initializeButtons = function () {
		if (_log) console.group('BingMap.Map.initializeButtons()');
		//Map Controls
		$('#zoomIn').on('click', function () {
			zoomMap('+');
		});
		$('#zoomOut').click('click', function () {
			zoomMap('-');
		});
		$('#resetMap').click('click', function () {
			softResetMap();
			tw.GeopointReports.resetAllPanes();
		});

	}





	/**
	 * (RE)initializeMap Microsoft map functionality AFTER bing maps library is loaded, will be triggered via callback > index.js > map.js
	 */
	var initializeMap = function (config) {
		if (_log) console.group('BingMap.Map.initializeMap()', config);
		if (_log) console.log('config:', config);

		//console.log("$('.js-preloader.map').width()" + $('.js-preloader.map').width());
		if ($('.js-preloader').length === 0) {
			addPreloaderMap();
		}

		reportInfoBoxArray = [];

		desktopCenter = new Microsoft.Maps.Location(45.205852, -89.83011); //(YY, XX)//45.205852, -92.03011
		tabletLandscapeCenter = new Microsoft.Maps.Location(45.205852, -89.83011);
		tabletPortraitCenter = new Microsoft.Maps.Location(44.73739, -88.8);
		mobileCenter = new Microsoft.Maps.Location(44.80282, -90.07542); //44.80282, -90.07542

		reportType = config.ReportType;
		baseCategory = 'Selfie Stand';

		if (_log) console.log('reportType:', reportType);
		if (_log) console.log('baseCategory:', baseCategory);

		//(TL:YY, TL:XX, BR:YY, BR:XX)
		wiBoundsOuter = Microsoft.Maps.LocationRect.fromEdges(53.882830, -104.858254, 37.131071, -75.932511);
		wiBounds = Microsoft.Maps.LocationRect.fromEdges(47.089442, -92.897646, 42.474545, -86.802900);


		trackResize(); //get initial window dims, set presets


		//https://docs.microsoft.com/en-us/bingmaps/v8-web-control/map-control-api/maptypeid-enumeration
		mapOptions = {
			allowHidingLabelsOfRoad: true,
			labelOverlay: Microsoft.Maps.LabelOverlay.hidden,
			mapTypeId: Microsoft.Maps.MapTypeId.mercator, //aerial,//grayscale//canvasLight//road//mercator
			maxZoom: 18,
			minZoom: 6,
			maxBounds: wiBoundsOuter,
			zoom: useZoom, //baseZoom,
			center: useCenterLocation, //centerLocation,
			enableSearchLogo: false,
			showScalebar: false,
			showDashboard: false,
			useInertia: false,
			disableKeyboardInput: true,
			disablePanning: false, //mobile.matches, // - remove all panning for MOBILE ONLY except when using the compass buttons
			liteMode: false,
			disableZooming: isDisableZoom//disable pinch/zoom and mousewheel zoom
		};
		if (_log) console.log('mapOptions:', mapOptions);

		map = new Microsoft.Maps.Map('#map', mapOptions);
		map.entities.clear();

		//Load the Clustering module.
		Microsoft.Maps.loadModule("Microsoft.Maps.Clustering", function () {
			if (_log) console.log('Microsoft.Maps.Clustering');
			isClusteringLoaded = true;
		});

		loadTopoTiles();

		addGroundOverlay();

		lastZoomLevel = map.getZoom();
		lastCenterLocation = map.getCenter();
		Microsoft.Maps.Events.addHandler(map, 'viewchangeend', viewChanged);
		// Microsoft.Maps.Events.addHandler(map, 'click', function (e) { 
		// 	alert('mapClick'); 
		// 	//moveToMapClick(e);
		// });
		
		//unload preloader
		$('.js-preloader').remove();

		if (_log) console.groupEnd();
	}





	//https://alastaira.wordpress.com/2011/02/19/using-esri-base-map-tile-layers-in-bing-maps/
	var loadTopoTiles = function () {
		//Define the tile source for the USGS Topo layer.
		var usgsTopoTileSource = new Microsoft.Maps.TileSource({
			uriConstructor: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{zoom}/{y}/{x}',
			minZoom: 1,
			maxZoom: 18
		});

		//Create a tile layer from the tile source
		var usgsTopoTileLayer = new Microsoft.Maps.TileLayer({
			mercator: usgsTopoTileSource
		});

		//Add tile layer to the map.
		map.layers.insert(usgsTopoTileLayer);
	}


	/**
	 * Add custom ground overlay
	 */
	var addGroundOverlay = function () {
		overlay = new Microsoft.Maps.GroundOverlay({
            bounds: wiBounds,
			imageUrl: '/images/public/wisconsin-shape.svg',
			//imageUrl: '/images/public/homepageSlide-tablet1.jpg',
            opacity: 0.5,
            rotation: 0  
        });
        map.layers.insert(overlay);
	}
	






	/**
	 * Map handler, watch for view port changes
	 * @param {*} e 
	 */
	var viewChanged = function (e) {
		clearTimeout(toMapReset);
		toMapReset = setTimeout(function(){ 
			var didChange = false;

			//console.log("clusterLayer.getVisible();", clusterLayer.getVisible());
			
			if (lastZoomLevel != map.getZoom()) {
				didChange = true;
				lastZoomLevel = map.getZoom();
				if (_log) console.log("viewChanged...lastZoomLevel", lastZoomLevel);
				map.setView({zoom: map.getZoom()});

			}
			if (lastCenterLocation != map.getCenter()) {
				didChange = true;
				lastCenterLocation = map.getCenter();
				if (_log) console.log("viewChanged...lastCenterLocation", lastCenterLocation);
			}
			//CLEAR OUT DETAILS: if NOT auto-zooming-into-pin, AND view-did-change AND reportsall is-hidden
			if (!isZoomingToPin && didChange && $('.js-reports').hasClass('is-hidden')) {
				tw.GeopointReportsListings.clearDetailsShowAll();
			}
		}, toMapResetMS);

		
	}//toMapReset



	/**
	 * Allow index.js to update reporttype here
	 */
	var updateReportType = function (type) {
		reportType = type;
		//if (_log) console.log('updateReportType.reportType:', reportType);
	}

	var getReportType = function () {
		return reportType;
	}




	/**
	 * Add Preloader Map template
	 * LOAD MAP PRELOADER IMMEDIATELY on initial load as soon as the file is ready
	 */
	var addPreloaderMap = function () {
		if (_log) console.log('addPreloaderMap()');
		var compiledTemplate = Template7.compile(preloaderMapTemplate),
			htmlPreloader = compiledTemplate();
		$('#map').html(htmlPreloader);
	}
	addPreloaderMap();




	/**
	 * Toggle pushpins if HandicapAccessible
	 * @param {*} isChecked 
	 */
	var togglePushpinCluster = function (isChecked) {
		var tempData = [];
		if (isChecked) {
			for (var i = 0; i < dataHold.length; i ++) {
				if (dataHold[i].IsHandicapAccessible) {
					tempData.push(dataHold[i]);
				}
			}
		} else {
			tempData = dataHold;
		}
		
		addPushpinCluster(tempData);
	}



	/**
	 * Add pushpin clusters to layer
	 * https://docs.microsoft.com/en-us/bingmaps/v8-web-control/map-control-concepts/clustering-module-examples/clusters-with-a-list-and-linking
	 * @param {*} data 
	*/
	var addPushpinCluster = function (data) {
		if (_log) console.log('addPushpinCluster()', data);

		if (dataHold == null) {
			dataHold = data;
		}

		if (clusterLayer != null) {
			clusterLayer.clear();
		}
		
		

		var intIsMapReady = setInterval(function () {
			//if (_log) console.log('addPushpinCluster().intIsMapReady');
			if (map != null && isClusteringLoaded) {
				clearInterval(intIsMapReady);

				//Add an infobox to the map.
				infobox = new Microsoft.Maps.Infobox(map.getCenter(), {
					visible: false
				});
				infobox.setMap(map);

				clusterLayer = new Microsoft.Maps.ClusterLayer(createCustomPushpins(data), {
					clusteredPinCallback: createCustomClusterPushpins,
					callback: createPushpinList,
					visible: true,
					setZIndex: 99999
				});
				if (_log) console.log('clusterLayer', clusterLayer);

				Microsoft.Maps.Events.addHandler(clusterLayer, 'click', function(e) {
					var pinType = (e.target instanceof Microsoft.Maps.ClusterPushpin) ? 'Cluster': 'Pushpin';
					//if (_log) console.log('------------- Clicked ', pinType, ': ', e.target);
					//alert('clusterLayer click4');
				});


				map.layers.insert(clusterLayer);

				
			}
		}, 200);


	}


	/**
	 * Create custom pushpins, inject extra datapoints
	 * @param {*} data 
	*/
	var createCustomPushpins = function (data) {

		var pins = [];
		for (var i = 0; i < data.length; i++) {

			var pushpinOptions = {
				//title: 'Pushpin #' + i,
				//typeName: 'pushpinStyle'
				//title: data[i].Title,
				color: colorPinSingle,
				// icon: 'Images/public/map_images/pin-blue.svg',
				// anchor: new Microsoft.Maps.Point(25, 28),
				// width: 25,
				// height: 28
			};

			var pinLocation = new Microsoft.Maps.Location(data[i].Latitude, data[i].Longitude);
			var pushpin = new Microsoft.Maps.Pushpin(pinLocation, pushpinOptions);
			
			//inject extra datapoints into pushpin
			pushpin.ID = data[i].ID;
			pushpin.index = i;
			pushpin.County = data[i].County;
			pushpin.DateModified = data[i].DateModified;
			pushpin.Latitude = data[i].Latitude;
			pushpin.Longitude = data[i].Longitude;
			pushpin.RegionName = data[i].RegionName;
			pushpin.Region = data[i].Region;
			pushpin.ReportType = data[i].ReportType;
			pushpin.ParentRegion = data[i].ParentRegion;
			pushpin.State = data[i].State;
			pushpin.City = data[i].City;
			pushpin.Zip = data[i].Zip;
			pushpin.Title = data[i].Title;
			pushpin.Address = data[i].Address;
			pushpin.PictureCount = data[i].PictureCount;
			pushpin.Images = data[i].Images;
			pushpin.IsHandicapAccessible = data[i].IsHandicapAccessible;
			pushpin.HandicapInstructions = data[i].HandicapInstructions;

			
			pins.push(pushpin);


			//Add handler for the pushpin click event.
			Microsoft.Maps.Events.addHandler(pins[i], 'click', pushpinClicked);
			//if (_log) console.log('addHandler.pushpinClicked.i', i);
		}

		return pins;
	}
	
	
	/**
	 * Create custom pushpin clusters
	 * @param {*} cluster 
	*/
	var createCustomClusterPushpins = function (cluster) {
		var minRadius = 12;
		var outlineWidth = 7;
		var fillColor = colorPinCluster;

		//Get the number of pushpins in the cluster
		var clusterSize = cluster.containedPushpins.length;

		//Calculate the radius of the cluster based on the number of pushpins in the cluster, using a logarithmic scale.
		var radius = Math.log(clusterSize) / Math.log(10) * 12 + minRadius;

		//Create an SVG string of two circles, one on top of the other, with the specified radius and color.
		var svg = ['<svg xmlns="http://www.w3.org/2000/svg" width="', (radius * 2), '" height="', (radius * 2), '">',
		    '<circle cx="', radius, '" cy="', radius, '" r="', radius, '" fill="', fillColor, '"/>',
		    '<circle cx="', radius, '" cy="', radius, '" r="', radius - outlineWidth, '" fill="', fillColor, '"/>',
			'</svg>'];
		
		//Create a title for the cluster.
		cluster.setOptions({
			//title: cluster.containedPushpins.length + ' pin cluster',//this shows up in the map as a label
			//color: colorPinCluster
			icon: svg.join(''),
			anchor: new Microsoft.Maps.Point(radius, radius),
			textOffset: new Microsoft.Maps.Point(0, radius - 6)
		});

		//Add handler for the cluster click event.
		Microsoft.Maps.Events.addHandler(cluster, 'click', clusterClicked); //pushpinClicked
		//if (_log) console.log('addHandler.clusterClicked.cluster', cluster);
	}



	/**
	 * Cluster clicked action
	 * @param {*} e 
	*/
	var clusterClicked = function (e) {
		if (_log) console.log('clusterClicked:', e);
		if (e.target.containedPushpins) {
			var locs = [];
			for (var i = 0, len = e.target.containedPushpins.length; i < len; i++) {
				//Get the location of each pushpin.
				locs.push(e.target.containedPushpins[i].getLocation());
			}

			//Create a bounding box for the pushpins.
			var bounds = Microsoft.Maps.LocationRect.fromLocations(locs);

			//Zoom into the bounding box of the cluster. 
			//Add a padding to compensate for the pixel area of the pushpins.
			map.setView({
				bounds: bounds,
				padding: 100
			});
			tw.Analytics.ga4(baseCategory, 'Map Cluster Click', '');
		}
	}


	/**
	 * Pushpin clicked action
	 * @param {*} e 
	*/
	var pushpinClicked = function (e) {
		if (_log) console.log('pushpinClicked()e:', e);
		//Show an infobox when a pushpin is clicked.
		//showInfobox(e.target);
		tw.GeopointReportsListings.getReportDetails(e.target.ID);

		//Data layer
		tw.Analytics.ga4(baseCategory, 'Map Location Click', 'Map - ' + e.target.Title);
		/*console.log('pushpinClicked - Map Location Click::', baseCategory, 'Map Location Click', 'Map - ' + e.target.Title);*/
	}

	/**
	 * Show infobox by grid key (what's in view pane)
	 * @param {*} gridKey 
	 */
	var showInfoboxByGridKey = function (gridKey) {
		if (_log) console.log('showInfoboxByGridKey:', gridKey);
		//Look up the cluster or pushpin by gridKey.
		var clusterPin = clusterLayer.getClusterPushpinByGridKey(gridKey);

		//Show an infobox for the cluster or pushpin.
		showInfobox(clusterPin);
	}



	/**
	 * Show infobox
	 */
	var showInfobox = function (pinData) {
		if (_log) console.log('showInfobox:', pinData);

		var infoboxOptions = {
			width: 30,
			height: 35,
			zIndex: 1,
			id: pinData.Title,
			offset: new Microsoft.Maps.Point(-18, 15)
		};
		var pinLocation = new Microsoft.Maps.Location(pinData.Latitude, pinData.Longitude);
		var pinInfobox = new Microsoft.Maps.Infobox(pinLocation, infoboxOptions);
		var compiledTemplate = Template7.compile(pinInfoboxSSTemplate);
		var jsonContent = {
			ID: pinData.ID,
			Title: pinData.Title
		};
		var htmlInfobox = compiledTemplate(jsonContent);
		pinInfobox.setHtmlContent(htmlInfobox);
		pinInfobox.setMap(map);
		reportInfoBoxArray.push(pinInfobox);
		
	}


	/**
	 * Create pushpin list, keep updated based on what is in view pane
	*/
	var createPushpinList = function () {
		if (_log) console.log('createPushpinList()');
		//Create a list of displayed pushpins each time clustering layer updates.

		if (clusterLayer != null) {
			infobox.setOptions({
				visible: false
			});
			

			//Get all pushpins that are currently displayed.
			var tempData = clusterLayer.getDisplayedPushpins();

			var data = sortArray(tempData, ['Title'], false);

			if (_log) console.log('clusterLayer.getDisplayedPushpins():', data);

			$('#reportsAll').html('');
			deleteReportInfoBoxes();

			//THIS WORKS WELL, JUST ABANDONED FOR NOW. HALF OF WHAT'S BELOW
			// //check to see if pin is cluster/single
			// var clusteredPinsArr = [];
			// for (var i = 0; i < data.length; i++) {
			// 	var gridKey = data[i].gridKey;
			// 	var clusterPin = clusterLayer.getClusterPushpinByGridKey(gridKey);
			// 	//console.log('gridKey.', gridKey, clusterPin);
			// 	if (clusterPin.containedPushpins) {
			// 		//console.log('^FOUND CLUSTER^: ', clusterPin.containedPushpins);
			// 		for (p = 0; p < clusterPin.containedPushpins.length; p++) {
			// 			var curID = clusterPin.containedPushpins[p].ID;
			// 			//push unique IDs into array
			// 			if (jQuery.inArray(curID, clusteredPinsArr ) == -1) {
			// 				clusteredPinsArr.push(curID);
			// 			}
			// 		}
			// 	}
			// }
			// //console.log('clusteredPinsArr:', clusteredPinsArr);


			// OL OPENER TAG, can't append() an opening tag without a closing tag
			var htmlBody = reportsOLOpenTemplate;

      		if (data.length > 0) {

				var compiledTemplateBody = Template7.compile(reportsAllBodySSTemplate);

				for (var i = 0; i < data.length; i++) {

					var jsonContentBody = {
						ID: data[i].ID,
						index: i,
						County: data[i].County,
						DateModified: data[i].DateModified,
						Latitude: data[i].Latitude,
						Longitude: data[i].Longitude,
						Address: data[i].Address,
						City: data[i].City,
						Zip: data[i].Zip,
						IsHandicapAccessible: data[i].IsHandicapAccessible,
						HandicapInstructions: data[i].HandicapInstructions,
						UGCFeed: data[i].UGCFeed,
						RegionName: data[i].RegionName,
						ReportType: reportType,
						ParentRegion: data[i].ParentRegion,
						State: data[i].State,
						Title: data[i].Title,
						PictureCount: data[i].PictureCount,
						Images: data[i].Images
					};
					//if (_log) console.log('jsonContentBody:', jsonContentBody);

					htmlBody += compiledTemplateBody(jsonContentBody);


					//THIS WORKS WELL, JUST ABANDONED FOR NOW. HALF OF WHAT'S ABOVE
					// //look for ID in array of clustered IDs
					// var lookForArr = jQuery.grep(clusteredPinsArr, function(element, index) {
					// 	return ( element == data[i].ID);
					// });
					// //console.log('lookForArr', lookForArr);
					// //ID is an individual pin, display infobox
					// if (lookForArr.length == 0) {
					// 	//console.log('ID is an individual pin, display infobox');
					// 	var infoboxOptions = {
					// 		width: 30,
					// 		height: 35,
					// 		zIndex: 1,
					// 		id: data[i].Title,
					// 		offset: new Microsoft.Maps.Point(-13, 0)
					// 	};
					// 	var pinLocation = new Microsoft.Maps.Location(data[i].Latitude, data[i].Longitude);
					// 	var pinInfobox = new Microsoft.Maps.Infobox(pinLocation, infoboxOptions);
					// 	var compiledTemplate = Template7.compile(pinInfoboxSSTemplate);
					// 	var jsonContent = {
					// 		ID: data[i].ID,
					// 		Title: data[i].Title
					// 	};
					// 	var htmlInfobox = compiledTemplate(jsonContent);
					// 	pinInfobox.setHtmlContent(htmlInfobox);
					// 	pinInfobox.setMap(map);
					// 	reportInfoBoxArray.push(pinInfobox);
					// }

				}





			} else {
				//htmlBody += '<div>no reports found</div>';
				var compiledTemplateBody = Template7.compile(noReportsTemplate);
				htmlBody += compiledTemplateBody();
			}

			//ADD REGION FOOTER, OL CLOSING TAG
			htmlBody += reportsOLCloseTemplate;
			//if (_log) console.log('htmlBody:', htmlBody);

			$('#reportsAll').append(htmlBody);

			if (dataHold.length == data.length) {

				$('.js-see-all').addClass('hidden');
			}
			else {

				$('.js-see-all').removeClass('hidden');
			}

		}
	}





	var deleteReportInfoBoxes = function () {
		// if (_log) console.log('deleteReportInfoBoxes()');
		// if (_log) console.log('reportInfoBoxArray.before..', reportInfoBoxArray);
		for (var i = 0; i < reportInfoBoxArray.length; i++) {
			//console.log(i, reportInfoBoxArray[i]);
			reportInfoBoxArray[i].setMap(null);
			//console.log('cleared');
		}

		reportInfoBoxArray = [];
		//if (_log) console.log('reportInfoBoxArray.clearout', reportInfoBoxArray);
	}







	/**
	 * Zoom in on pin after details load
	 * @param {*} lat 
	 * @param {*} long 
	 */
	var zoomToPin = function(lat, long){
		//if (_log) console.log('zoomToPin:', lat, long);
		isZoomingToPin = true;
		var pinLocation = new Microsoft.Maps.Location(lat, long);

		map.setView({
			zoom: 11,
			center: pinLocation
		});

		setTimeout(function(){ 
			isZoomingToPin = false;
		}, toMapResetMS * 2);

	}


	var moveToMapClick = function (e) {
		if (_log) console.log('moveToMapClick:', e);
		if (e.targetType == "map") {
			var point = new Microsoft.Maps.Point(e.getX(), e.getY());
			var loc = e.target.tryPixelToLocation(point);
			var mapLocation = new Microsoft.Maps.Location(loc.latitude, loc.longitude);
			map.setView({
				center: mapLocation
			});
		}

	}






	/**
	 * Soft reset map.
	 * for use when map is centered/zoomed on local reports, zoom out to initial state and clear infoxboxes and cetering ring.
	 */
	var softResetMap = function () {
		if (_log) console.group('softResetMap()');

		map.setView({
			zoom: useZoom,
			center: useCenterLocation
		});

		if (_log) console.groupEnd();
	}


	/**
	 * Zoom Map
	 * @param {*} direction 
	 * @param {*} location 
	 */
	var zoomMap = function (direction, location) {
		if (_log) console.log('zoomMap():', direction, location);

		if (direction === '+') {
			var newZoom = map.getZoom() + 1;
			map.setView({
				zoom: newZoom,
				center: location
			});
		} else if (direction === '-') {
			var newZoom = map.getZoom() - 1;
			map.setView({
				zoom: newZoom,
				center: location
			});
		} else if (typeof direction === 'number') {
			map.setView({
				zoom: direction,
				center: location
			});
		}
		if (_log) console.log('zoomLevel: ', getZoomLevel());
	};

	/**
	 * Get Zoom Level of map
	 */
	var getZoomLevel = function () {
		return map.getZoom();
	};


	/**
	 * Sort multi-dimensional array by a key
	 * @param arr: array of items to sort:  nameOfArray[]
	 * @param keyArr : array of keys to sort by: ['keyOne', 'keyTwo']
	 * @param reverse : boolean : true/false
	 * Usage: let tempData = this.sortArray(this.dataFake, ['Other'], true);
	*/
	var sortArray = function(arr, keyArr, reverse) {
		// console.group('sortArray()');
		// console.log('arr', arr);
		// console.log('keyArr', keyArr);
		// console.log('reverse', reverse);
		// console.groupEnd();

		var sortOrder = 1;
		if (reverse) sortOrder = -1;
		return arr.sort(function (a, b) {
			var x = a, y = b;
			for (var i = 0; i < keyArr.length; i++) {
				x = x[keyArr[i]];
				y = y[keyArr[i]];
			}
			return sortOrder * ((x < y) ? -1 : ((x > y) ? 1 : 0));
		});
	}

	/**
	 * Recalculate zoom upon init/resize
	 */
	var recalculateZoom = function () {
		if (_log) console.group('recalculateZoom()');
		if (isMobile) {
			useZoom = mobileZoom;
			useCenterLocation = mobileCenter;
		} else {
			// if (isTouch) {
			// 	useZoom = baseZoom;
			// 	useCenterLocation = tabletLandscapeCenter;
			// } else {
				useZoom = baseZoom;
				useCenterLocation = desktopCenter;
			//}
			
		}


		if (_log) console.log('isMobile', isMobile);
		if (_log) console.log('useZoom', useZoom);
		if (_log) console.log('useCenterLocation', useCenterLocation);

		if (map != null) {
			var options = {
				zoom: useZoom,
				center: useCenterLocation
			}
			if (_log) console.log('options', options);
			map.setView(options);
		}
		if (_log) console.groupEnd();

	};




	/**
	 * track resize event, update map if needed
	 */
	var trackResize = function () {
		if (_log) console.log('trackResize()');
		BingMap.Utilities.viewportDimensions();

		if (window.innerWidth < breakPoints.main) {
			isMobile = true;
		} else {
			isMobile = false;
		}

		if (wasMobile != isMobile) {
			if (_log) console.log('isMobile changed!!! update map. isMobile:', isMobile);
			wasMobile = isMobile;
			recalculateZoom();
		}
		// if (_log) console.log('wasMobile:', wasMobile);
		// if (_log) console.log('isMobile:', isMobile);
	}




	return {
		addPushpinCluster: addPushpinCluster,
		// getMapInit: getMapInit,
		getReportType: getReportType,
		initializeMap: initializeMap,
		initializeButtons: initializeButtons,
		showInfoboxByGridKey: showInfoboxByGridKey,
		showInfobox: showInfobox,
		softResetMap: softResetMap,
		togglePushpinCluster: togglePushpinCluster,
		trackResize: trackResize,
		updateReportType: updateReportType,
		zoomToPin: zoomToPin
	}

}();